export default function lerpColor(v) {

  let idx = Math.floor((1 - v) * 15);
  let col = 'rgba(9, 101, 170, 1)';

  // lerp color doesn't work on IE :(
  switch (idx) {
    case 0:
      col = 'rgba(14, 107, 171, 1)';
      break; // 0
    case 1:
      col = 'rgba(20, 112, 172, 1)';
      break; // 1
    case 2:
      col = 'rgba(25, 117, 173, 1)';
      break; // 1.5
    case 3:
      col = 'rgba(30, 122, 174, 1)';
      break; // 2
    case 4:
      col = 'rgba(35, 128, 175, 1)';
      break; // 2.5
    case 5:
      col = 'rgba(41, 133, 176, 1)';
      break; // 3
    case 6:
      col = 'rgba(46, 138, 177, 1)';
      break; // 3.5
    case 7:
      col = 'rgba(51, 144, 178, 1)';
      break; // 4
    case 8:
      col = 'rgba(56, 149, 179, 1)';
      break; // 4.5
    case 9:
      col = 'rgba(62, 154, 180, 1)';
      break; // 5
    case 10:
      col = 'rgba(67, 160, 181, 1)';
      break; // 5.5
    case 11:
      col = 'rgba(72, 165, 182, 1)';
      break; // 6
    case 12:
      col = 'rgba(77, 170, 183, 1)';
      break; // 6.5
    case 13:
      col = 'rgba(83, 175, 184, 1)';
      break; // 7
    case 14:
      col = 'rgba(88, 181, 185, 1)';
      break; // 7.5
    case 15:
      col = 'rgba(93, 186, 186, 1)';
      break; // 8
  }

  return col;

}